export const commerceApiOrigin = (import.meta.env.VITE_COMMERCE_API_ORIGIN || '').replace(/\/$/, '')
export const catalogOrigin = (import.meta.env.VITE_CATALOG_ORIGIN || '').replace(/\/$/, '')

export const storefrontFaultCopy =
  '現在購入手続きをご利用いただけません。商品は引き続きご覧いただけます。'
